const DatagridColumnApi = {
    // Append options from outside the editor to the current column
    addOptions: function(newOptions, skipDuplicates = false) {
      let c = jQuery('#add-options-from-library')

      if (c) {
          c.attr('data-skip-duplicates', skipDuplicates)
          c.attr('newoptions', newOptions)
          c.trigger("click")
      }
  },
}

export default DatagridColumnApi;